import React from 'react';
import PropTypes from 'prop-types';
import { imageResponsiveService } from '../../../domain/services/imageResponsiveService';
import { headService } from '../../../domain/services/headService';

export const ImageSources = ({ sources, preload = false }) => {
  if (!sources || !sources[0]) {
    return null;
  }
  let previousWidth;

  return (
    <>
      {sources.map((source, index) => {
        const webpUrl = imageResponsiveService.getWebpUrl(source.srcSet);
        // The browser goes through a list of <source> elements to find a
        // format it supports. It uses the *first one* it can display.
        // Hence, we must use max-width instead of min-width.
        const media = `(max-width: ${source.width}px)`;
        const srcSet = webpUrl === source.srcSet ? source.srcSet : webpUrl;
        const type = webpUrl === source.srcSet ? undefined : 'image/webp';
        let preloadMedia;
        if (preload) {
          const preloadMediaParts = [];
          if (previousWidth) {
            preloadMediaParts.push(`(min-width: ${previousWidth + 1}px)`);
          }
          if (index !== sources.length - 1) {
            preloadMediaParts.push(`(max-width: ${source.width}px)`);
          }
          preloadMedia = preloadMediaParts.join(' and ');
          previousWidth = source.width;
          // Add preload link
          headService.link({
            rel: 'preload',
            as: 'image',
            href: srcSet,
            media: preloadMedia
          });
        }
        return (
          <source
            key={source.width}
            media={media}
            srcSet={srcSet}
            type={type}
          />
        );
      })}
    </>
  );
};

ImageSources.propTypes = {
  sources: PropTypes.arrayOf(
    PropTypes.shape({
      width: PropTypes.number.isRequired,
      srcSet: PropTypes.string.isRequired
    })
  ),
  preload: PropTypes.bool
};
